document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.horizontal-track');

  sections.forEach(section => {
    const frame = section.querySelector('.horizontal-frame');
    const items = section.querySelectorAll('.horizontal-item').length;
    section.style.setProperty('--scroll-items', items);

    window.addEventListener('scroll', () => {
      const rect = section.getBoundingClientRect();
      const start = rect.top;
      const height = rect.height - window.innerHeight;
      const scrollProgress = Math.min(1, Math.max(0, -start / height));
      const translateX = -scrollProgress * (items - 1) * window.innerWidth;
      frame.style.transform = `translateX(${translateX}px)`;
    });
  });
});
